import { idccAutoriseTT } from '@/features/domaine/regles-akto/shared'
import { storeToRefs } from 'pinia'
import { computed, type InjectionKey } from 'vue'
import { buildDemandeActions } from '../shared'
import { useDemandeAFStore } from './useDemandeAFStore'

type DemandeAFActions = ReturnType<typeof useDemandeAFActions>
export const AF_ACTIONS: InjectionKey<DemandeAFActions> = Symbol('af-actions')

export function useDemandeAFActions() {
  const store = useDemandeAFStore()

  const { model } = storeToRefs(store)

  const actionsDemande = buildDemandeActions({
    store: store as any,
    typeDocumentTemplate: computed(() => null),
  })

  const estTypePublicVisible = computed(() => {
    const idcc = model.value?.employeur?.etablissement?.idcc?.code
    return idccAutoriseTT.includes(idcc ?? '')
  })

  return {
    ...actionsDemande,
    estTypePublicVisible,
  }
}
